<template>
    <div>
         <my-form ref="faq_form" v-if="faq">
            <div v-for="(group, group_index) in faq.data">
                <div class="row">
                    <div class="col-md-10">
                        <v-text-field :rules="[validationRules.required]" outlined dense :label="$t('Group name')" class="no-validation" v-model="group.name"></v-text-field>
                    </div>
                    <div class="col-md-2">
                        <v-btn small height="42px" class="py-1 w-100" color="grey lighten-3" @click="(!group.no_expand)? $set(group, 'no_expand', true) : group.no_expand = false"><span v-if="!group.no_expand"><v-icon class="mr-2">mdi-arrow-up</v-icon>{{$t('Hide group')}}</span><span v-else><v-icon class="mr-2">mdi-arrow-down</v-icon>{{$t('Expand group')}}</span></v-btn>
                    </div>
                </div>
                <v-list class="px-0 pl-4">
                            <span class="w-100" v-if="!group.no_expand">
                                <v-list-item v-for="(item, item_index) in group.items" class="pl-0">
                                    <v-list-item-content>
                                        <div>
                                            <v-text-field :rules="[validationRules.required]" outlined label="Question" v-model="item.question"></v-text-field>
                                            <v-textarea :rules="[validationRules.required]" class="no-validation" label="answer" outlined v-model="item.answer"></v-textarea>
                                        </div>
                                    </v-list-item-content>
                                    <v-list-item-action><v-btn @click="faq.data[group_index].items.splice(item_index, 1)" fab color="red" dark><v-icon>mdi-trash-can</v-icon></v-btn></v-list-item-action>
                                </v-list-item>
                                <v-list-item class="pl-0">
                                    <v-list-item-content>
                                        <div class="row mx-0 justify-end">
                                            <v-btn @click="faq.data.splice(group_index, 1)" class="mr-2" color="red" dark>{{$t('Delete group')}}</v-btn>
                                            <v-btn color="primary" dark @click="faq.data[group_index].items.push({})">{{$t('Add element to group')}} {{group.name}}</v-btn>
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                            </span>
                </v-list>
            </div>
        </my-form>
        <v-btn color="primary" dark @click="faq.data.push({items: []})">{{$t('Add new group')}}</v-btn>
    </div>
</template>
<script>
    import {getBreads, storeBread, editBread} from "../../api/bread";
    import Vue from 'vue';
    export default {
        props:['value'],
        data:() => {
            return{
                faq:null
            }
        },
        watch:{
            faq: function () {
                this.$emit('input', this.faq);
            }
        },
        computed:{
          selectedWebsite(){
              return this.$store.getters.activeWebsite;
          }
        },
        mounted() {
            this.faq = this.value;
            Vue.prototype.$faqs = this;
            if(!this.faq){
                this.setDefault();
            }
        },
        methods:{
            setDefault(){
                this.faq = {
                    type: 'faq',
                    data: [{
                        name: 'Main',
                        items:[]
                    }],
                }
            },
            save(){
                return new Promise((resolve, reject) => {
                    if(this.$refs.faq_form.my_validate()){
                        if(this.faq.id){
                            var func = editBread('Attachment', {model_name: 'Website/Attachment', ...this.faq}, this.faq.id);
                        }else{
                            var func = storeBread('Attachment', {model_name: 'Website/Attachment', ...this.faq});
                        }
                        func.then(response => {
                            this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Saved succesfully'), type: 'success'})
                            resolve();
                        }).catch(e => {
                            this.$store.commit('app/ADD_MESSAGE', {text: 'Error', type: 'error'})
                            reject();
                        })
                    }else{
                        reject();
                    }
                })

            }
        }
    }
</script>
